import { initializeApp } from 'firebase/app';
import { 
  getAuth, 
  GoogleAuthProvider, 
  FacebookAuthProvider,
  onAuthStateChanged as firebaseOnAuthStateChanged
} from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID
};

const hasUsableFirebaseConfig = Boolean(
  firebaseConfig.apiKey &&
  firebaseConfig.authDomain &&
  firebaseConfig.projectId &&
  firebaseConfig.appId
);

let app = null;
let auth = null;
let db = null;
let googleProvider = null;
let facebookProvider = null;
let isFirebaseEnabled = false;

if (hasUsableFirebaseConfig) {
  try {
    app = initializeApp(firebaseConfig);
    auth = getAuth(app);
    // Use identity-db if configured, otherwise default
    db = getFirestore(app, 'identity-db');
    googleProvider = new GoogleAuthProvider();
    facebookProvider = new FacebookAuthProvider();
    // The backend resolves accounts by email (getByEmail), so always request an
    // email from Facebook — otherwise a user with no shared email can't be linked.
    facebookProvider.addScope('email');
    facebookProvider.addScope('public_profile');
    isFirebaseEnabled = true;
  } catch (error) {
    console.warn('[Firebase] Disabled because initialization failed:', error.message);
  }
} else {
  console.warn('[Firebase] Disabled because VITE_FIREBASE_* config is incomplete. Backend login remains available.');
}

const onAuthStateChanged = (authInstance, callback) => {
  if (!isFirebaseEnabled || !authInstance) {
    queueMicrotask(() => callback(null));
    return () => {};
  }

  return firebaseOnAuthStateChanged(authInstance, callback);
};

export { 
  auth, 
  db,
  isFirebaseEnabled,
  googleProvider, 
  facebookProvider, 
  onAuthStateChanged 
};
export default app;
